// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { toTenantUrl } from '../app/core/config/tenant';

const defaultTenant = 'us1';

export const environment = {
  production: false,
  DEFAULT_DEV_TENANT: defaultTenant,
  KEYCLOAK_TENANTS: ['us1', 'greenhouse'],
  PRODUCT_NAME: 'fastr',
  CLIENT_ID: 'spa',
  REDIRECT_UI: toTenantUrl('https://TENANT.dev.fastr.ai/', defaultTenant),
  LOGOUT_URL: toTenantUrl('https://TENANT.dev.fastr.ai/', defaultTenant),
  API_BASE_URL: toTenantUrl('https://TENANT.dev.fastr.ai:443/api/private/fastr', defaultTenant),
  BRANDFETCH_CLIENT_ID: '1idohRgWlTB4dRMCLeY',
  KEYCLOAK_URL: 'https://auth.dev.fastr.ai/',
  AUTH0_DOMAIN: 'mojo-dev.auth0.com',
  AUTH0_CLIENT_ID: 'yp7L5PQUdI8EvDGJsfcQ2henbmoZdbt0',
  AUTH0_AUDIENCE: 'https://irp.dev.mojorank.com/',
  MS_CLIENT_ID: '95bb0ffc-830f-487e-af36-1a4efb8682e6',
  GM_CLIENT_ID: '927136947586-509gcgheenbh9m7j65qcor30mj7pq3k6.apps.googleusercontent.com',
  GM_URL: 'https://accounts.google.com/o/oauth2/v2/auth',
  GM_TOKEN_URL: 'https://oauth2.googleapis.com/token',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
